import { createFileRoute } from '@tanstack/react-router';

import { PublicCardOnFileWrapper } from '../components/PublicCardOnFile/PublicCardOnFileWrapper';

// Dev has no kalos-public deployment, so dev.kalosflorida.com serves the card
// link page itself — same arrangement as payment.$token.
export const Route = createFileRoute('/card/$token')({
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useParams();

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicCardOnFileWrapper token={token} />
    </div>
  );
}
